import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MENU_OPTIONS } from 'src/constants/SettingsMenuOptions';
import { useGetCurrentUser } from 'src/hooks';
import { getMenuOptions } from 'src/utils/settingUtils';

// ----------------------------------------------------------------------

const MobileSettingsNav = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const navigate = useNavigate();
    const location = useLocation();
    const { isSuperUser } = useGetCurrentUser();

    if (!isMobile) return null;

    const options = getMenuOptions(MENU_OPTIONS, isSuperUser) || [];

    return (
        <Box
            sx={{
                display: 'flex',
                overflowX: 'auto',
                gap: 1,
                pb: 1,
                mb: 2,
                '&::-webkit-scrollbar': { height: 4 },
                '&::-webkit-scrollbar-thumb': {
                    bgcolor: 'rgba(145, 158, 171, 0.24)',
                    borderRadius: 2,
                },
            }}
        >
            {options.map((option) => {
                const isActive = location.pathname === option.linkTo;
                return (
                    <Chip
                        key={option.value}
                        label={option.label}
                        variant={isActive ? 'filled' : 'outlined'}
                        color={isActive ? 'primary' : 'default'}
                        onClick={() => navigate(option.linkTo)}
                        sx={{
                            flexShrink: 0,
                            fontWeight: isActive ? 600 : 400,
                            cursor: 'pointer',
                            borderRadius: '8px',
                            fontSize: '0.8125rem',
                            ...(isActive && {
                                bgcolor: '#00A76F',
                                color: '#fff',
                                borderColor: '#00A76F',
                                '&:hover': { bgcolor: '#007B55' },
                            }),
                            ...(!isActive && {
                                borderColor: 'rgba(145, 158, 171, 0.32)',
                                color: theme.palette.text.secondary,
                                '&:hover': {
                                    bgcolor: 'rgba(0, 167, 111, 0.08)',
                                    borderColor: '#00A76F',
                                },
                            }),
                        }}
                    />
                );
            })}
        </Box>
    );
};

export default MobileSettingsNav;
